import { ClimbingArea } from "../types";
import { apiDomain } from "../utils/climbingAreaUtils";
import { getCachedArea, setCachedArea } from "./areaCache";

async function fetchAreaDetail(areaId: string, useCache: boolean = true): Promise<ClimbingArea> {

    // Check cache first
    if (useCache) {
        const cached = getCachedArea(areaId);
        if (cached) {
            return cached;
        }
    }

    const baseUrl = new URL("https://" + apiDomain());
    const url = new URL('/area/detail/' + areaId, baseUrl);
    url.searchParams.append('days', '7');

    const response = await fetch(url.toString());
    const area: ClimbingArea = await response.json();
    if (response.ok && area) {
        // Cache the result
        setCachedArea(areaId, area);
        return area;
    } else {
        return Promise.reject(new Error(response.statusText));
    }
}

export default fetchAreaDetail;